export default "<div class=\"home-container\">\n  <div class=\"login-container\">\n    <app-login></app-login>\n  </div>\n</div>"